import ImageBWDm from '../../assets/img/ourTeam/picturePNG/dima_bw.png'
import ImageBWTimur from '../../assets/img/ourTeam/picturePNG/timur_bw.png'
import ImageBWAnd from '../../assets/img/ourTeam/picturePNG/andrey_bw.png'
import ImageBWBog from '../../assets/img/ourTeam/picturePNG/bohdan_bw.png'
import ImageBWNat from '../../assets/img/ourTeam/picturePNG/natalia_bw.png'
import ImageBWNaz from '../../assets/img/ourTeam/picturePNG/nazar_bw.png'
import ImageBWSer from '../../assets/img/ourTeam/picturePNG/serhii_bw.png'
import ImageBWRomP from '../../assets/img/ourTeam/picturePNG/roma_bw.png'


export const ImgBWData = [
	{
		imgBW: ImageBWTimur,
  },
  {
    imgBW: ImageBWAnd,
  },
  {
    imgBW: ImageBWBog,
  },
  {
    imgBW: ImageBWNat,
  },
  {
    imgBW: ImageBWNaz,
  },
  {
    imgBW: ImageBWSer,
  },
  {
    imgBW: ImageBWRomP,
  },
  {
    imgBW: ImageBWDm,
  },
]
